import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, provide, ref, onMounted } from "vue";
import cms from "../../services/cms/cms";
import { CmsImage, CmsResourceRelationship } from "../../services/cms/cms-type-definitions";
import CmsImg from "./cms-img.vue";
import ResourceTile from "./resource-tile.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-tile',
  props: {
    link: {}
  },
  setup(__props: any) {

const props = __props;

const tileImage = ref<InstanceType<typeof CmsImg> | null>(null);
provide("cmsTileImage", tileImage);

const href = computed(() => {
  if (!props.link) {
    return null;
  }
  return cms.linkResolver(props.link);
});

const title = computed(() => {
  if (!props.link) {
    return null;
  }

  return cms.asText(props.link.data?.tile_title).trim() || cms.asText(props.link.data?.title);
});

const src = computed<CmsImage | undefined>(() => {
  if (!props.link) {
    return undefined;
  }
  return props.link.data?.title_image?.tile || props.link.data?.title_image;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ResourceTile, {
    title: title.value,
    href: href.value,
    class: "cms-tile"
  }, {
    default: _withCtx(() => [
      _createVNode(CmsImg, {
        src: src.value,
        ref_key: "tileImage",
        ref: tileImage
      }, null, 8, ["src"])
    ]),
    _: 1
  }, 8, ["title", "href"]))
}
}

})